import "./index.scss";

import React from "react";

import { IconButton } from "@/components/Elements";

type Props = {
  open: boolean;
  onClose: (save: boolean) => void;
  children?: React.ReactNode;
};

function Modal({ open, onClose, children }: Props) {
  if (!open) {
    return null;
  }
  return (
    <div className="modal">
      <div className="modal-window">
        <IconButton
          icon="close"
          transparent
          className="modal-close-button"
          onClick={() => onClose(false)}
        />
        {children}
      </div>
    </div>
  );
}

export default Modal;
